module.exports = __webpack_public_path__ + "static/img/3.5858e2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/rollImg/rollSale/3.jpg
// module id = 2ub8
// module chunks = 0